import React from 'react'
import SelectActivity from '../components/SelectActivity'

function Activities() {
    return (
        <div>
            <SelectActivity />
        </div>
    )
}

export default Activities
